export default __webpack_public_path__ + "static/media/ingredient-search.20b68221.png";